const MaintenancePoller = () => null;

export default MaintenancePoller;
